export {
  Root as Popover,
  Close as PopoverClose,
  Trigger as PopoverTrigger,
} from "@rn-primitives/popover";
